import { Phone, ArrowDown, Check, Sparkles } from 'lucide-react';
import { companyInfo, heroContent, keyBenefits, whatsappLink } from '../data/mock';
import { WhatsAppIcon } from './WhatsAppIcon';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_laser-busters/artifacts/2ala9m3d_Screenshot_2026-01-31-00-11-44-62_92460851df6f172a4592fca41cc2d2e6.jpg";

export const HeroSection = () => {
  return (
    <section className="hero-dark wood-bg">
      <div className="container max-w-5xl">
        {/* Logo */}
        <div className="mx-auto mb-8 animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
          <img 
            src={LOGO_URL} 
            alt="Borer Busters Logo" 
            className="h-40 md:h-52 w-auto mx-auto object-contain"
          />
        </div>

        {/* Main Headline */}
        <h1 
          className="heading-hero text-gold mb-4 animate-fade-in-up"
          style={{ animationDelay: '0.2s' }}
        >
          {heroContent.headline}
        </h1>

        {/* Subheadline */}
        <p 
          className="heading-2 mb-6 animate-fade-in-up"
          style={{ 
            color: 'var(--text-light)',
            animationDelay: '0.3s' 
          }}
        >
          {heroContent.subheadline}
        </p>

        {/* Tagline */}
        <p 
          className="body-large mb-2 max-w-2xl mx-auto animate-fade-in-up"
          style={{ 
            color: 'var(--gold-primary)',
            animationDelay: '0.4s' 
          }}
        >
          {heroContent.tagline}
        </p>
        
        <p 
          className="body-medium mb-8 animate-fade-in-up italic"
          style={{ 
            color: 'var(--text-muted)',
            animationDelay: '0.45s' 
          }}
        >
          — {heroContent.highlight}
        </p>

        {/* PRICE TAG - Main Hook */}
        <div 
          className="mb-8 animate-fade-in-up"
          style={{ animationDelay: '0.5s' }}
        >
          <div className="inline-block">
            <div 
              className="price-tag pulse-gold text-center"
              style={{ padding: '1.25rem 2.5rem' }}
            >
              <div className="flex items-center justify-center gap-2 mb-1">
                <Sparkles size={20} />
                <span className="text-sm uppercase tracking-widest">Starting At Just</span>
                <Sparkles size={20} />
              </div>
              <div className="text-4xl md:text-5xl font-bold">
                ₹{companyInfo.startingPrice}
              </div>
              <div className="text-xs mt-1 opacity-80">
                One-time investment
              </div>
            </div>
          </div>
        </div>

        {/* Key Benefits */}
        <div 
          className="flex flex-wrap items-center justify-center gap-3 mb-8 animate-fade-in-up"
          style={{ animationDelay: '0.6s' }}
        >
          {keyBenefits.slice(0, 3).map((benefit, index) => (
            <div 
              key={index}
              className="flex items-center gap-2 px-4 py-2 rounded-full"
              style={{ 
                background: 'rgba(212, 168, 75, 0.15)',
                border: '1px solid var(--border-gold)'
              }}
            >
              <Check size={16} style={{ color: 'var(--gold-primary)' }} />
              <span className="body-small" style={{ color: 'var(--text-light)' }}>
                {benefit}
              </span>
            </div>
          ))}
        </div>

        {/* CTA Buttons */}
        <div 
          className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8 animate-fade-in-up"
          style={{ animationDelay: '0.7s' }}
        >
          <a 
            href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
            data-testid="hero-call-btn"
            className="btn-gold text-lg"
            style={{ padding: '1.25rem 2.5rem' }}
          >
            <Phone size={22} />
            <span>Call {companyInfo.phone}</span>
          </a>
          <a 
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-whatsapp-btn"
            className="flex items-center justify-center gap-3 rounded font-display font-bold uppercase tracking-wider text-lg transition-transform hover:-translate-y-0.5"
            style={{ 
              padding: '1.25rem 2.5rem',
              background: '#25D366',
              color: '#fff',
              textDecoration: 'none',
              boxShadow: '0 4px 20px rgba(37, 211, 102, 0.35)'
            }}
          >
            <WhatsAppIcon size={22} />
            <span>WhatsApp Us</span>
          </a>
        </div>

        <p 
          className="mono-text text-sm animate-fade-in-up"
          style={{ 
            color: 'var(--text-muted)',
            animationDelay: '0.8s' 
          }}
        >
          Visitation + Inspection + Estimation charges are ₹1,999 (waived off in 1st booking) • By Appointment Only • South Mumbai
        </p>

        {/* Scroll Indicator */}
        <div 
          className="mt-12 animate-fade-in-up"
          style={{ animationDelay: '0.9s' }}
        >
          <ArrowDown 
            size={28} 
            className="mx-auto animate-bounce"
            style={{ color: 'var(--gold-primary)', opacity: 0.6 }} 
          />
        </div>
      </div>
    </section>
  );
};
